import axiosInstance from "../axiosInstance";

/* ========================================================================== */
/* Vehículo (DEPRECATED — vehID-first)                                        */
/* ========================================================================== */
export const getVehicleLastLocation = async ({ vehid, manid }) => {
  const { data } = await axiosInstance.get(`/gps/vehicles/${vehid}/last`, { params: { manid } });
  return data;
};

export const getVehicleTrackHistory = async ({ vehid, manid }) => {
  const { data } = await axiosInstance.get(`/gps/vehicles/${vehid}/history`, { params: { manid } });
  return data;
};

export const getVehicleStreamTicket = async ({ vehid, manid }) => {
  const { data } = await axiosInstance.get(`/gps/vehicles/${vehid}/stream-ticket`, { params: { manid } });
  return data;
};

export const getVehicleStreamUrl = ({ vehid, manid, ticket }) => {
  const baseURL = (axiosInstance?.defaults?.baseURL || "").replace(/\/$/, "");
  const qs = new URLSearchParams({
    manid: String(manid),
    ticket: String(ticket),
    t: String(Date.now()),
  });
  return `${baseURL}/gps/vehicles/${vehid}/stream?${qs.toString()}`;
};

/* ========================================================================== */
/* Manifiesto (manID-first)                                                   */
/* ========================================================================== */
export const getManifestLastLocation = async (manid) => {
  const { data } = await axiosInstance.get(`/gps/manifests/${manid}/last`);
  return data;
};

export const getManifestTrackHistory = async (manid) => {
  const { data } = await axiosInstance.get(`/gps/manifests/${manid}/history`);
  return data;
};

export const getManifestStreamTicket = async (manid) => {
  const { data } = await axiosInstance.get(`/gps/manifests/${manid}/stream-ticket`);
  return data;
};

export const getManifestStreamUrl = ({ manid, ticket }) => {
  const baseURL = (axiosInstance?.defaults?.baseURL || "").replace(/\/$/, "");
  const qs = new URLSearchParams({ ticket: String(ticket), t: String(Date.now()) });
  return `${baseURL}/gps/manifests/${manid}/stream?${qs.toString()}`;
};

/* ========================================================================== */
/* Rutas                                                                       */
/* ========================================================================== */
export const getManifestPlannedRoute = async (manid) => {
  const { data } = await axiosInstance.get(`/gps/route/${manid}`);
  return data;
};

export const getManifestLiveRoute = async (manid) => {
  const { data } = await axiosInstance.get(`/gps/route/${manid}/live`);
  return data;
};

export const getManifestLiveRouteHistory = async (manid, { limit = 100, beforeId } = {}) => {
  const { data } = await axiosInstance.get(`/gps/route/${manid}/live/history`, {
    params: { limit, beforeId },
  });
  return data;
};

export const getManifestLiveRouteStats = async (manid) => {
  const { data } = await axiosInstance.get(`/gps/route/${manid}/live/stats`);
  return data;
};

/** ETA ligera (polling barato). Cachea 30s en backend. */
export const getManifestLiveRouteEta = async (manid) => {
  const { data } = await axiosInstance.get(`/gps/route/${manid}/live/eta`);
  return data;
};

/**
 * Track real "pegado" a calles.
 * @param {number} manid
 * @param {{ format?: 'feature'|'simple', limit?: number }} opts
 *   - feature: FeatureCollection con colores por velocidad (default en v7)
 *   - simple : { type, coordinates } — fallback v6
 */
export const getManifestMatchedTrack = async (manid, { format = 'feature', limit } = {}) => {
  const { data } = await axiosInstance.get(`/gps/manifests/${manid}/matched-track`, {
    params: { format, ...(limit ? { limit } : {}) },
  });
  return data;
};

/* ========================================================================== */
/* Sala de monitoreo                                                          */
/* ========================================================================== */
export const getActiveManifests = async () => {
  const { data } = await axiosInstance.get(`/gps/monitoring/active`);
  return data;
};

export const getMonitoringStreamTicket = async () => {
  const { data } = await axiosInstance.get(`/gps/monitoring/active/stream-ticket`);
  return data;
};

export const getMonitoringStreamUrl = ({ ticket }) => {
  const baseURL = (axiosInstance?.defaults?.baseURL || "").replace(/\/$/, "");
  const qs = new URLSearchParams({ ticket: String(ticket), t: String(Date.now()) });
  return `${baseURL}/gps/monitoring/active/stream?${qs.toString()}`;
};

export const getManifestInfo = async (manid) => {
    const { data } = await axiosInstance.get(`/gps/manifests/${manid}/info`);
    return data;
};